import script from "./BaseSalesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSalesCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseSalesCard.vue?vue&type=style&index=0&id=0dc1f8dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc1f8dc"]])

export default __exports__